import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SysAdminService } from "../../services/sysadmin.service";
import { SchoolsToChangeModel } from "./SchoolsToChangeModel";
import { UserGroupAddSchoolComponent } from "./user-group-add-school/user-group-add-school.component";

@Component({
	selector: "caass-user-group-assign-school",
	templateUrl: "./user-group-assign-school.component.html",
	styleUrls: ["./user-group-assign-school.component.css"],
})
export class UserGroupAssignSchoolComponent implements OnInit {
	constructor(private sysAdminService: SysAdminService, private dialogService: DialogService) {}

	ngOnInit(): void {}

	ngOnChanges() {
		this.errorMessage = "";

		if (this.SelectedUserGroup != undefined && this.SelectedUserGroup != null) {
			this.loadSchoolList();
		} else {
			this.lstSchools = [];
		}
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	@Input() AllowMultipleSchools: boolean = false;
	@Input() SchoolID: any;
	@Input() SelectedUserGroup: any;
	@Input() Update: any;

	lstSchools: any = [];
	SelectedSchools: any = [];

	lstSchoolContainer: any = [];

	cols = [
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
		{ field: "SchoolContainer", header: "School Container" },
	];

	pagerows: any = 5;
	pagefirst: any = 0;

	errorMessage: any = "";

	loading: any = false;

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////
	private loadSchoolList() {
		this.loading = true;

		var result = this.sysAdminService.UserGroupGetSchools(this.SelectedUserGroup.UserGroupID);
		result.subscribe(
			(response) => {
				this.lstSchools = response;
				this.SelectedSchools = [];

				for (var i = 0; i < this.lstSchools.length; i++) {
					var next = this.lstSchools[i];
					if (next.SchoolContainer == "") {
						next.SchoolContainer = "N/A";
					}
				}

				this.lstSchoolContainer = Array.from(new Set(this.lstSchools.map((item: any) => item.SchoolContainer))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		if (this.SelectedUserGroup == undefined || this.SelectedUserGroup == null) {
			this.errorMessage = "Select a User Group to add schools to";
			return;
		}

		if (this.SelectedUserGroup.UserLevelID == 3 && this.AllowMultipleSchools == false && this.SelectedSchools.length == 1) {
			this.errorMessage = "School Level Groups can only be assigned to one school";
			return;
		}

		var ref = this.dialogService.open(UserGroupAddSchoolComponent, {
			header: "Add Schools",
			width: "fit-content",
			data: {
				UserLevelID: this.SelectedUserGroup.UserLevelID,
				AllowMultipleSchools: this.AllowMultipleSchools,
				SchoolID: this.SchoolID,
				SelectedSchools: this.lstSchools,
				UserGroupID: this.SelectedUserGroup.UserGroupID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadSchoolList();
			}
		});
	}

	onRemove() {
		this.errorMessage = "";

		// if(this.SelectedUsers.length == 0){
		//   this.errorMessage = "Select users to remove";
		//   return;
		// }

		for (var i = 0; i < this.SelectedSchools.length; i++) {
			var nextSchool = this.SelectedSchools[i];

			if (nextSchool.SchoolContainer != "N/A") {
				this.errorMessage =
					"Cannot remove schools that are part of an assigned school container (schools in red). Please remove the associated container(s) first.";
				break;
			}
		}

		var lstSchoolID: number[] = [];

		for (var i = 0; i < this.SelectedSchools.length; i++) {
			var next = Number(this.SelectedSchools[i].SchoolID);
			lstSchoolID = [...lstSchoolID, next];
		}

		//Create Query Data
		let data: SchoolsToChangeModel = {
			UserGroupID: this.SelectedUserGroup.UserGroupID,
			SchoolIDs: lstSchoolID,
		};

		//Call SP
		var result = this.sysAdminService.UserGroupRemoveSchools(data);
		result.subscribe(
			(response) => {
				this.loadSchoolList();
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Events
	/////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	/////////////////////////////////////////
}
